import { FloatingNode } from '@floating-ui/react';
import React, { useContext } from 'react';
import { MenuContext } from "../../context/MenuContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function ContextMenuColumnNode({
  children
}) {
  const {
    nodeId
  } = useContext(MenuContext);
  return /*#__PURE__*/_jsx(FloatingNode, {
    id: nodeId,
    children: children
  });
}